import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

export const getSocialLinks = () =>
  fetchApi({
    url: apiUrls.home.social_links,
    method: 'get'
  })

export const getProductGroups = () =>
  fetchApi({
    url: apiUrls.home.product_groups,
    method: 'get'
  })

export const getPinnedProducts = () =>
  fetchApi({
    url: apiUrls.home.pinned_products,
    method: 'get'
  })

export const getTopNews = () =>
  fetchApi({
    url: apiUrls.home.top_news,
    method: 'get'
  })